import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { featureList } from '../helpers';
import { MARKETING_FEATURE_GROUP } from './group';

export { MARKETING_FEATURE_GROUP } from './group';

export const MARKETING_FEATURES = {
  READ: {
    guid: 'e1a5b8d3-4c67-4e82-9d41-8a2b3f5c0100',
    name: 'marketing:read',
    description: 'View the marketing workspace page',
    action: 'read',
    product: 'marketing',
    parentGuid: MARKETING_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export const MARKETING_MODULE: FeatureModule = {
  product: 'marketing',
  groups: [],
  features: featureList(MARKETING_FEATURES),
};

export const ALL_MARKETING_MODULES: FeatureModule[] = [MARKETING_MODULE];

export const ALL_MARKETING_FEATURE_GROUPS: FeatureGroup[] = [
  MARKETING_FEATURE_GROUP,
  ...ALL_MARKETING_MODULES.flatMap((m) => m.groups),
];

export const ALL_MARKETING_FEATURES: Feature[] = ALL_MARKETING_MODULES.flatMap((m) => m.features);
